export default {
  install(Vue) {
    Vue.prototype.$error = ({
      duration = 10000,
      message = "",
      type = "error"
    }) => {
      Vue.prototype.$message({
        duration,
        message,
        type
      });
    };

    Vue.prototype.$notifySuccess = msg => {
      Vue.prototype.$notify({
        title: "成功",
        message: msg || "操作成功",
        type: "success"
      });
    };
  }
};
